import config from '../../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

export const KPI_MONTHLY_CHARGEBACK_COUNT_LOAD = 'KPI/KPI_MONTHLY_CHARGEBACK_COUNT_LOAD';
export const KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS = 'KPI/KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS';
export const KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE = 'KPI/KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE';

export const KPI_TRANSACTION_SUMMARY_LOAD = 'KPI/KPI_TRANSACTION_SUMMARY_LOAD';
export const KPI_TRANSACTION_SUMMARY_SUCCESS = 'KPI/KPI_TRANSACTION_SUMMARY_SUCCESS';
export const KPI_TRANSACTION_SUMMARY_FAILURE = 'KPI/KPI_TRANSACTION_SUMMARY_FAILURE';

export function getKpiMonthlyChargebackCount(merchantIds) {
    const queryParamsString = createQueryParams({ merchantIds });

    return {
        failureActionTypeOrCreator: getKpiMonthlyChargebackCountFailureActionCreator,
        fetchParams: {
            url: `${config.chargebackApiUrl}/getMonthlyChargebackCount${queryParamsString}`
        },
        loadActionTypeOrCreator: KPI_MONTHLY_CHARGEBACK_COUNT_LOAD,
        successActionTypeOrCreator: getKpiMonthlyChargebackCountSuccessActionCreator
    };
}

export function getKpiMonthlyChargebackCountSuccessActionCreator(monthlyChargebackCount) {
    return {
        monthlyChargebackCount,
        type: KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS
    };
}

export function getKpiMonthlyChargebackCountFailureActionCreator(error) {
    return {
        error,
        type: KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE
    };
}

export function getKpiTransactionSummary(merchantIds) {
    const queryParamsString = createQueryParams({ merchantIds });

    return {
        failureActionTypeOrCreator: getKpiTransactionSummaryFailureActionCreator,
        fetchParams: {
            url: `${config.transactionsApiUrl}/getMerchantTransactionSummary${queryParamsString}`
        },
        loadActionTypeOrCreator: KPI_TRANSACTION_SUMMARY_LOAD,
        successActionTypeOrCreator: getKpiTransactionSummarySuccessActionCreator
    };
}

export function getKpiTransactionSummarySuccessActionCreator(summary) {
    return {
        summary,
        type: KPI_TRANSACTION_SUMMARY_SUCCESS
    };
}

export function getKpiTransactionSummaryFailureActionCreator(error) {
    return {
        error,
        type: KPI_TRANSACTION_SUMMARY_FAILURE
    };
}
